import { Button, Table, Pagination, Checkbox } from "rsuite";
import styles from "./ComponentMaintenance.module.css";
import { useComponentMaintenance } from "./useComponentMaintenance";
import { ActionsIcon } from "../../../Settings/Components/Locations/Locations";
import ComponentMaintenanceModal from "./Components/ComponentMaintenanceModal/ComponentMaintenanceModal";
import { useComponentMaintenanceModal } from "./Components/ComponentMaintenanceModal/useComponentMaintenanceModal";
import ConfirmationModal from "../../../../Components/ConfirmationModal/ConfirmationModal";
import { useConfirmationModal } from "../../../../Components/ConfirmationModal/useConfirmationModal";
import MessageModal from "../../../../Components/MessageModal/MessageModal";
import { useMessageModal } from "../../../../Components/MessageModal/useMessageModal";
import {
  getAccessLevel,
  getResponsibleName,
} from "../../../../helperFunctions";
import { useEffect } from "react";
const { Column, HeaderCell, Cell } = Table;

function ComponentMaintenance({ locationId }) {
  let {
    componentMaintenanceArrayLength,
    itemsPerPage,
    activePage,
    setActivePage,
    getComponentMaintenance,
    componentMaintenance,
    statusHandler,
  } = useComponentMaintenance();

  let {
    showCreateComponentMaintenanceModal,
    showEditComponentMaintenanceModal,
  } = useComponentMaintenanceModal();

  let { showConfirmationModal } = useConfirmationModal();
  let { showMessageModal } = useMessageModal();

  useEffect(() => {
    getComponentMaintenance();
  }, [activePage]);

  let ActiveCell = ({ rowData, dataKey, ...props }) => {
    const handleStatusChange = (v, c) => {
      const accessLevel = getAccessLevel();
      const responsibleName = getResponsibleName();

      // Check if user has access level 5
      if (
        accessLevel < 5 //&&
        //(responsibleName != "TSI" && responsibleName != "Admin")
      ) {
        showMessageModal("accessForbidden");
        return;
      }

      // If unchecking (deactivating), show confirmation modal
      if (!c) {
        showConfirmationModal(
          "deactivateJob",
          () => statusHandler(v, c, rowData["_id"]),
          2 // Force modal to show
        );
      } else {
        // If checking (activating), proceed without confirmation
        statusHandler(v, c, rowData["_id"]);
      }
    };

    return (
      <>
        <Cell {...props}>
          <>
            <Checkbox
              style={{ marginTop: "-7px" }}
              onChange={handleStatusChange}
              checked={rowData[dataKey] == "active" ? true : false}
            />
          </>
        </Cell>
      </>
    );
  };

  let ActionsCell = ({ rowData, dataKey, ...props }) => {
    return (
      <>
        <Cell {...props}>
          <div className={styles.actions_cell_container}>
            {rowData["status"] != "deleted" && (
              <ActionsIcon
                type="edit"
                onEdit={() => {
                  showEditComponentMaintenanceModal(rowData[dataKey]);
                }}
              />
            )}
          </div>
        </Cell>
      </>
    );
  };

  let NameCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} title={`JobID: ${rowData["jobId"]}`}>
        {rowData[dataKey]}
      </Cell>
    );
  };

  //! Render

  return (
    <>
      <div className={styles.container}>
        <div className={styles.component_maintenance_header}>
          <div className={styles.component_maintenance_header_title}>
            Job Planning{" "}
          </div>
          <div className={styles.component_maintenance_header_options}>
            <Button
              onClick={showCreateComponentMaintenanceModal}
              color="blue"
              appearance="primary"
              style={{ width: "200px", marginRight: "20px" }}
            >
              Add Planned Job
            </Button>
          </div>
        </div>

        <div className={styles.table_container}>
          <Table autoHeight data={componentMaintenance}>
            <Column width={300} resizable>
              <HeaderCell>ID</HeaderCell>
              <Cell dataKey="_id" />
            </Column>
            <Column width={300} resizable>
              <HeaderCell>Job name</HeaderCell>
              <NameCell dataKey="name" />
            </Column>

            <Column width={150}>
              <HeaderCell>Period Type</HeaderCell>
              <Cell dataKey="periodType" />
            </Column>

            <Column width={150}>
              <HeaderCell>Period</HeaderCell>
              <Cell dataKey="period" />
            </Column>

            <Column width={200} resizable>
              <HeaderCell>Counter No</HeaderCell>
              <Cell dataKey="counterNumber" />
            </Column>

            {/* <Column width={150}>
    <HeaderCell>Last done</HeaderCell>
    <Cell dataKey="lastDone" />
  </Column>

  <Column width={150}>
    <HeaderCell>Due date</HeaderCell>
    <Cell dataKey="dueDate" />
  </Column> */}

            <Column width={100}>
              <HeaderCell>Active</HeaderCell>
              <ActiveCell dataKey="status" />
            </Column>

            <Column width={100}>
              <HeaderCell>Actions</HeaderCell>
              <ActionsCell dataKey="_id" />
            </Column>
          </Table>

          <div className={styles.pagination_container}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              size="xs"
              layout={["total", "-", "pager"]}
              total={componentMaintenanceArrayLength}
              limit={itemsPerPage}
              activePage={activePage}
              onChangePage={setActivePage}
            />
          </div>
        </div>
      </div>

      <ComponentMaintenanceModal locationId={locationId} />
      <ConfirmationModal />
      <MessageModal />
    </>
  );
}

export default ComponentMaintenance;
